<template>
  <div class="bar">
    <div class="bar-progress" :class="{ active: step === 1 || step === 2 || step === 3 }">
      <i class="bike-icon far fa-bicycle" v-if="step === 1"></i>
    </div>
    <div class="bar-step bar-step-one" :class="{ active: step === 1 || step === 2 || step === 3 }">
      <span class="bar-step-number">1</span>
    </div>
    <div class="bar-progress" :class="{ active: step === 2 || step === 3 }">
      <i class="bike-icon far fa-bicycle" v-if="step === 2"></i>
    </div>
    <div class="bar-step bar-step-two" :class="{ active: step === 2 || step === 3 }">
      <span class="bar-step-number">2</span>
    </div>
    <div class="bar-progress" :class="{ active: step === 3 }">
      <i class="bike-icon far fa-bicycle" v-if="step === 3"></i>
    </div>
  </div>
</template>
<script>
import "./ProgressBar.scss";

export default {
  name: "ProgressBar",
  props: {
    step: {
      type: Number,
      required: true,
    },
  },
};
</script>
